import { Alert, Dialog, Stack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import { ExpenseCategoryDatabase } from '../../../../types';
import { useExpenseCategoryFormDialog } from './useExpenseCategoryFormDialog';

type Props = {
  onClose: () => void;
  afterSuccess?: (category: ExpenseCategoryDatabase) => void;
};

export default function ExpenseCategoryFormDialog(props: Props) {
  const hook = useExpenseCategoryFormDialog(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      onSubmit={hook.onSubmit}
      maxWidth="sm"
      fullWidth
      title="Nouvelle catégorie de dépenses"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Créer la catégorie',
          type: 'submit',
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          control={hook.form.control}
          name="name"
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom"
              placeholder="Ex. : Eau, Électricité, Ascenseur"
              fullWidth
              required
              autoFocus
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Controller
          control={hook.form.control}
          name="description"
          render={({ field }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Description"
              fullWidth
              multiline
              minRows={3}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
